<template>
  <div id="contenedor-configuracion-default">
    <!-- Header -->
    <div class="mb-6">
      <h1 class="text-h4 font-weight-bold primary--text mb-1">
        Configuración del Sistema
      </h1>
      <p class="text-body-1 grey--text text--darken-1 mb-0">
        Administra los catálogos y opciones del sistema
      </p>
    </div>

    <!-- Grid de secciones -->
    <v-row>
      <!-- Catálogos Geográficos -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-map-marker-outline</v-icon>
            Geográficos
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosGeograficos"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Catálogos Personas -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-account-group-outline</v-icon>
            Personas
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosPersonas"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Catálogos Financieros -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-currency-usd</v-icon>
            Financieros
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosFinancieros"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Catálogos de Obra -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-hard-hat</v-icon>
            Obra
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosObra"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Seguridad -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-shield-account-outline</v-icon>
            Seguridad
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosSeguridad"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Auditoría -->
      <v-col cols="12" md="6" lg="4">
        <v-card class="config-card rounded-lg" elevation="2">
          <v-card-title class="config-card-header grey darken-3 white--text">
            <v-icon left color="white">mdi-clipboard-check-outline</v-icon>
            Auditoría
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list dense class="py-0">
              <v-list-item
                v-for="item in catalogosAuditoria"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                class="config-list-item"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="20" color="base3">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="16" color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracionDefault',
  data() {
    return {
      catalogosGeograficos: [
        {
          ruta: 'catalogoEntidades',
          nombre: 'Entidades',
          icono: 'mdi-domain',
        },
        {
          ruta: 'catalogoMunicipios',
          nombre: 'Municipios',
          icono: 'mdi-city-variant-outline',
        },
      ],
      catalogosPersonas: [
        {
          ruta: 'catalogoContratistas',
          nombre: 'Contratistas',
          icono: 'mdi-account-hard-hat',
        },
        {
          ruta: 'catalogoFuncionarios',
          nombre: 'Funcionarios',
          icono: 'mdi-account-tie-outline',
        },
      ],
      catalogosFinancieros: [
        {
          ruta: 'catalogoFuentesFinancieras',
          nombre: 'Fuentes Financieras',
          icono: 'mdi-bank-outline',
        },
        {
          ruta: 'catalogoProgramasInversion',
          nombre: 'Programas de Inversión',
          icono: 'mdi-briefcase-outline',
        },
        {
          ruta: 'catalogoDeducciones',
          nombre: 'Deducciones',
          icono: 'mdi-percent-outline',
        },
      ],
      catalogosObra: [
        {
          ruta: 'catalogoTiposObra',
          nombre: 'Tipos de Obra',
          icono: 'mdi-shape-outline',
        },
        {
          ruta: 'catalogoSubTiposObra',
          nombre: 'Sub Tipos de Obra',
          icono: 'mdi-shape-plus-outline',
        },
        {
          ruta: 'catalogoEtiquetas',
          nombre: 'Etiquetas',
          icono: 'mdi-tag-multiple-outline',
        },
        {
          ruta: 'catalogoContratosEstatus',
          nombre: 'Estatus de Contratos',
          icono: 'mdi-list-status',
        },
        {
          ruta: 'catalogoExpedientes',
          nombre: 'Expedientes',
          icono: 'mdi-folder-open-outline',
        },
      ],
      catalogosSeguridad: [
        {
          ruta: 'catalogoUsuarios',
          nombre: 'Usuarios',
          icono: 'mdi-account-group-outline',
        },
      ],
      catalogosAuditoria: [
        {
          ruta: 'catalogoEntesFiscalizadores',
          nombre: 'Entes Fiscalizadores',
          icono: 'mdi-bank-check',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.config-card {
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  }
}

.config-card-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
}

.config-list-item {
  min-height: 44px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background-color 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--v-bkground-base) !important;
  }
}
</style>
